import React from 'react'
import cn from 'classnames'
import { Form, Select } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'

import Button from '../Button'
import PageHeader from '../PageHeader'
import {
  CUSTOMER_HELP_QUESTION_OPTIONS,
  NUMBER_OF_EMPLOYEES_OPTIONS,
  INDUSTRY_OPTIONS,
} from '../../sharedForm/constants'

import sharedStyles from '../../sharedForm/styles.less'
import SaveIndicator from '../../sharedForm/SaveIndicator'

class CompanyPage extends React.PureComponent {
  state = {
    focusedField: null,
  }

  setCurrentSupportSolution = value => {
    const { onChange, formFields } = this.props
    formFields.currentSupportSolution = ''
    onChange('currentSupportSolution', value, null, { validate: true })
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    if (name === 'currentSupportSolutionSelect') {
      if (value === 'Other') {
        this.setCurrentSupportSolution('')
      } else {
        this.setCurrentSupportSolution(value)
      }
    }
    if (name === 'currentSupportSolutionText') {
      this.setCurrentSupportSolution(value)
    }
    onChange(name, value, null, { validate: true })
  }

  handleFocus = name => {
    this.setState({ focusedField: name })
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    this.setState({ focusedField: null })
    onValidate(name, formFields[name])
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
    } = this.props
    const { focusedField } = this.state
    return (
      <React.Fragment>
        <PageHeader primary="Tell us a bit about your organization" />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV2)}
        >
          <Form.Field>
            <label htmlFor="name">Organization name</label>
            <ValidatedField
              placeholder="Where do you work?"
              name="name"
              value={formFields.name}
              errorMessage={focusedField !== 'name' && formFieldsErrors.name}
              onChange={propFunc(this.handleChange, 'name')}
              onFocus={propFunc(this.handleFocus, 'name')}
              onBlur={propFunc(this.handleBlur, 'name')}
              fieldRefCallback={disableLastPassInputRef}
              autoFocus
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="currentSupportSolutionSelect">
              How do you currently help your customers?
            </label>
            <Select
              name="currentSupportSolutionSelect"
              className="large"
              options={CUSTOMER_HELP_QUESTION_OPTIONS}
              value={formFields.currentSupportSolutionSelect}
              placeholder="- Please select -"
              onChange={propFunc(
                this.handleChange,
                'currentSupportSolutionSelect'
              )}
            />
          </Form.Field>
          <Form.Field>
            {formFields.currentSupportSolutionSelect === 'Other' && (
              <ValidatedField
                placeholder="How do you currently help your customers?"
                name="currentSupportSolutionText"
                value={formFields.currentSupportSolutionText}
                errorMessage={
                  focusedField !== 'currentSupportSolutionText' &&
                  formFieldsErrors.hearAboutUs
                }
                onChange={propFunc(
                  this.handleChange,
                  'currentSupportSolutionText'
                )}
                onFocus={propFunc(
                  this.handleFocus,
                  'currentSupportSolutionText'
                )}
                onBlur={propFunc(this.handleBlur, 'currentSupportSolutionText')}
                fieldRefCallback={disableLastPassInputRef}
                autoFocus
                maxLength="191"
              />
            )}
          </Form.Field>
          <Form.Field>
            <label htmlFor="numberOfEmployees">
              How many people from your team will be using Groove?
            </label>
            <Select
              name="numberOfEmployees"
              className="large"
              options={NUMBER_OF_EMPLOYEES_OPTIONS}
              value={formFields.numberOfEmployees}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'numberOfEmployees')}
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="industry">What&apos;s your industry?</label>
            <Select
              name="industry"
              className="large"
              options={INDUSTRY_OPTIONS}
              value={formFields.industry}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'industry')}
            />
          </Form.Field>
          <Button disabled={!canSave} onClick={submitForm}>
            {!saving ? (
              'Continue'
            ) : (
              <SaveIndicator animate>Saving</SaveIndicator>
            )}
          </Button>
        </Form>
      </React.Fragment>
    )
  }
}

export default CompanyPage
